/** @module Enums */ /** typedoc */
var FeatureEnum;
(function (FeatureEnum) {
    FeatureEnum["LowResMp3"] = "LowResMp3";
    FeatureEnum["SoundCloudOgg"] = "SoundCloudOgg";
    FeatureEnum["HiResMp3"] = "HiResMp3";
    FeatureEnum["Wav"] = "Wav";
    FeatureEnum["SoundCloudWav"] = "SoundCloudWav";
    FeatureEnum["HdWav"] = "HdWav";
    FeatureEnum["StemMp4"] = "StemMp4";
    FeatureEnum["Video"] = "Video";
    FeatureEnum["Distribution"] = "Distribution";
})(FeatureEnum || (FeatureEnum = {}));

export { FeatureEnum };
